<template>
	<div name="hrms75e-popup-tab4" id="hrms75e-popup-tab4" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">

		  <div class="modal-content">
		  	<div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		     	  <h4 class="modal-title">{{ labels['HRMS75EC7']['10'] }}</h4>
		    </div>

		    <div class="modal-body detail detail-responsive">
					<div class="box-body">
              <hrms-table :columns="detailTab4PopupColumns" 
                          :data="detailTab4Popup"
                          :searchDisp="false" 
                          :selectRowBool="false"
                          :selectBtnDisp="true"
                          :selectEvent="selectEvent"
                          :confirmSelectBtnDisp="false"
                          ref="popupTab4" />

           </div>
        </div>
        <div class="modal-footer" >
          <button type="button" class="btn bg-color-skin pull-left" data-dismiss="modal" @click="triggerPopupTab4()"><i class="fa fa-check-circle"></i>{{ labelsButton['approve'] }}</button>
        </div>
		  </div>
		 </div>
	</div>

</template>

<script>
export default {
  name: 'hrms75e-popup-tab4',
  data () {
    return {
      btn_close: 'Close',
      selectedRow: []
    }
  },
  props: [ 'labels', 'nowLang', 'detailTab4Popup', 'detail', 'labelsButton', 'detailTab4PopupColumns', 'setAddCodcours' ],
  methods: {
    triggerPopupTab4 () {
      this.$refs.popupTab4.$emit('$selectEventBuiltIn')
    },
    selectEvent (checkedDataRows) {
      this.setAddCodcours(checkedDataRows)
    }
  }
}
</script>


// WEBPACK FOOTER //
// popupTab4.vue?366217a6